import { FaUsers } from "react-icons/fa6";
const roles = {
  id: 'roles',
  title: '',
  type: 'group',
  children: [
    {
      id: 'roles-management',
      title: 'Role',
      type: 'item',
      url: '/roles',
      icon: FaUsers,
      allowedRoles: ['admin', 'superAdmin'],
      breadcrumbs: false
    }
  ]
};

export default roles;
